export const isString = (value: any) => typeof value === 'string';
export const isObject = (value: any) => typeof value === 'object';
